(() => {
  const BLOGS = {
    faq: "/blogs/faq/",
    magazin: "/blogs/magazin/"
  };

  // Chips (Beliebte Suchbegriffe) – KEINE Mobile-Begrenzung
  const POPULAR_CHIPS = [
    "Stickrahmen",
    "Rahmenerkennung",
    "Stickvlies",
    "VP3",
    "Stickdatei",
    "Unterfaden",
    "Oberfaden",
    "Kappenrahmen",
    "mySewnet",
    "Creativate"
  ];

  // Mini-Hilfe
  const HELP_RULES = [
    {
      terms: ["rahmen", "erkannt"],
      title: "Kurzhilfe: Rahmenerkennung",
      text: "Prüfe: Rahmen korrekt eingerastet, Adapter/Position passend, Sensorflächen sauber, Maschine neu starten. Wenn ein Rahmen geht und der andere nicht: Rahmen/Adapter-Kombi prüfen."
    },
    {
      terms: ["faden", "riss"],
      title: "Kurzhilfe: Fadenriss",
      text: "Neu einfädeln, Nadel tauschen, Spannung leicht reduzieren, und Material/Vlies ausreichend stabilisieren. Bei sehr dichten Motiven ggf. Geschwindigkeit reduzieren."
    },
    {
      terms: ["vp3"],
      title: "Kurzhilfe: Dateiformat",
      text: "VP3 ist ein Stickdateiformat (keine Schrift). Schriften liegen meist als einzelne Dateien pro Buchstabe oder als Maschinen-Schriftbibliothek vor."
    }
  ];

  // Query-Expansion (Komposita)
  const EXPANSIONS = [
    { trigger: "rahmen", add: ["stickrahmen", "rahmenerkennung", "rahmengröße"] },
    { trigger: "datei", add: ["stickdatei", "dateiformat", "vp3", "dst", "pes"] }
  ];

  const DEBOUNCE_MS = 180;

  const debounce = (fn, d = 180) => {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...a), d);
    };
  };

  const escapeHtml = (s) =>
    (s || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const normalize = (s) =>
    (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const levenshtein = (a, b) => {
    const m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    const dp = Array.from({ length: n + 1 }, (_, i) => i);
    for (let i = 1; i <= m; i++) {
      let prev = dp[0];
      dp[0] = i;
      for (let j = 1; j <= n; j++) {
        const tmp = dp[j];
        dp[j] = Math.min(
          dp[j] + 1,
          dp[j - 1] + 1,
          prev + (a[i - 1] === b[j - 1] ? 0 : 1)
        );
        prev = tmp;
      }
    }
    return dp[n];
  };

  const getQueryTokens = (q) => (q || "").match(/[\p{L}\p{N}]+/gu) || [];

  function highlightTitle(title, query) {
    const tokens = getQueryTokens(query).map(normalize).filter(Boolean);
    if (!tokens.length) return escapeHtml(title);

    return (title || "").replace(/([\p{L}\p{N}]+)/gu, (w) => {
      const nw = normalize(w);
      const hit = tokens.some((t) => {
        if (nw === t) return true;
        if (nw.length >= 4 && t.length >= 4) {
          const dist = levenshtein(nw, t);
          const threshold = Math.min(2, Math.floor(Math.max(nw.length, t.length) / 6) + 1);
          return dist <= threshold;
        }
        return false;
      });
      return hit ? `<strong>${escapeHtml(w)}</strong>` : escapeHtml(w);
    });
  }

  async function fetchSuggestArticles(query, limit) {
    const url =
      `/search/suggest.json?q=${encodeURIComponent(query)}` +
      `&resources[type]=article&resources[limit]=${encodeURIComponent(limit)}`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Suggest API error");
    const data = await res.json();
    return data?.resources?.results?.articles || [];
  }

  function filterByScope(items, scope) {
    if (scope === "all") return items;
    const prefix = BLOGS[scope];
    if (!prefix) return items;
    return items.filter((a) => (a?.url || "").startsWith(prefix));
  }

  function dedupeByUrl(items) {
    const seen = new Set();
    const out = [];
    for (const it of items) {
      const u = it?.url;
      if (!u || seen.has(u)) continue;
      seen.add(u);
      out.push(it);
    }
    return out;
  }

  function buildQueries(baseQuery) {
    const qNorm = normalize(baseQuery);
    const queries = new Set([baseQuery]);

    for (const rule of EXPANSIONS) {
      if (qNorm.includes(rule.trigger)) {
        for (const extra of rule.add) queries.add(extra);
      }
    }
    return Array.from(queries).slice(0, 4);
  }

  function badgeForUrl(url) {
    if ((url || "").startsWith(BLOGS.faq)) return "FAQ";
    if ((url || "").startsWith(BLOGS.magazin)) return "Magazin";
    return "";
  }

  function renderChips(chipsEl, onClickChip) {
    chipsEl.innerHTML = POPULAR_CHIPS.map((t) => {
      const safe = escapeHtml(t);
      return `<button type="button" class="article-live-search__chip" data-chip="${safe}">${safe}</button>`;
    }).join("");

    chipsEl.querySelectorAll("[data-chip]").forEach((btn) => {
      btn.addEventListener("click", () => onClickChip(btn.getAttribute("data-chip")));
    });
  }

  function matchHelpRule(query) {
    const q = normalize(query);
    for (const rule of HELP_RULES) {
      if (rule.terms.every((term) => q.includes(normalize(term)))) return rule;
    }
    return null;
  }

  function renderHelp(helpEl, rule) {
    if (!rule) {
      helpEl.hidden = true;
      helpEl.innerHTML = "";
      return;
    }
    helpEl.innerHTML = `
      <div class="article-live-search__help-title">${escapeHtml(rule.title)}</div>
      <div class="article-live-search__help-text">${escapeHtml(rule.text)}</div>
    `;
    helpEl.hidden = false;
  }

  function readSuggestions(root) {
    const el = root.querySelector("[data-als-suggestions]");
    if (!el) return { faq: [], magazin: [] };
    try {
      const parsed = JSON.parse(el.textContent || "{}");
      return {
        faq: Array.isArray(parsed.faq) ? parsed.faq : [],
        magazin: Array.isArray(parsed.magazin) ? parsed.magazin : []
      };
    } catch {
      return { faq: [], magazin: [] };
    }
  }

  function renderSuggestionList(resultsEl, suggestions, scope) {
    let list = [];
    if (scope === "faq") list = suggestions.faq || [];
    else if (scope === "magazin") list = suggestions.magazin || [];
    else list = [...(suggestions.faq || []), ...(suggestions.magazin || [])];

    // Max 10 (5 + 5) – KEINE Mobile-Begrenzung
    list = list.slice(0, 10);

    if (!list.length) {
      resultsEl.innerHTML = "";
      resultsEl.hidden = true;
      return;
    }

    resultsEl.innerHTML = list
      .map((a) => {
        const badge = badgeForUrl(a.url);
        return `
          <a class="article-live-search__item" href="${a.url}">
            <span class="article-live-search__item-title">${escapeHtml(a.title)}</span>
            ${badge ? `<small>${badge}</small>` : ``}
          </a>
        `;
      })
      .join("");

    resultsEl.hidden = false;
  }

  function renderResults(resultsEl, items, query) {
    if (!items.length) {
      resultsEl.innerHTML = `<div class="article-live-search__empty">Keine Treffer</div>`;
      return;
    }

    resultsEl.innerHTML = items
      .map((a) => {
        const url = a.url;
        const badge = badgeForUrl(url);
        const titleHtml = highlightTitle(a.title || "", query);
        return `
          <a class="article-live-search__item" href="${url}">
            <span class="article-live-search__item-title">${titleHtml}</span>
            ${badge ? `<small>${badge}</small>` : ``}
          </a>
        `;
      })
      .join("");
  }

  function init(root) {
    const input = root.querySelector(".article-live-search__input");
    const select = root.querySelector("[data-article-live-search-scope]");
    const resultsEl = root.querySelector("[data-als-results]");
    const overlay = root.querySelector("[data-article-live-search-overlay]");
    const chipsEl = root.querySelector("[data-als-chips]");
    const helpEl = root.querySelector("[data-als-help]");
    const suggestions = readSuggestions(root);

    if (!input || !select || !resultsEl || !overlay || !chipsEl || !helpEl) return;

    const limit = Number(root.dataset.limit || 6);
    const minChars = Number(root.dataset.minChars || 2);

    const dsScope = (root.dataset.defaultScope || "all").toLowerCase();
    if (["all", "faq", "magazin"].includes(dsScope)) select.value = dsScope;

    const open = () => root.classList.add("article-live-search--focus");
    const close = () => {
      root.classList.remove("article-live-search--focus");
      chipsEl.hidden = true;
      helpEl.hidden = true;
      resultsEl.hidden = true;
    };

    // Chips initialisieren
    renderChips(chipsEl, (chip) => {
      input.value = chip;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.focus();
    });

    overlay.addEventListener("click", () => input.blur());

    input.addEventListener("focus", () => {
      open();
      const q = input.value.trim();
      if (q.length < minChars) {
        chipsEl.hidden = false;
        renderHelp(helpEl, null);
        renderSuggestionList(resultsEl, suggestions, select.value || "all");
      }
    });

    input.addEventListener("blur", () => setTimeout(close, 150));

    // Shortcut: Cmd+K / Ctrl+K
    document.addEventListener("keydown", (e) => {
      const isK = (e.key || "").toLowerCase() === "k";
      if (!(e.metaKey || e.ctrlKey) || !isK) return;

      const active = document.activeElement;
      const tag = (active?.tagName || "").toLowerCase();
      const typing = tag === "input" || tag === "textarea" || active?.isContentEditable;
      if (typing && active !== input) return;

      e.preventDefault();
      input.focus();
      if (typeof input.select === "function") input.select();
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Escape") input.blur();
    });

    const runSearch = debounce(async () => {
      const q = input.value.trim();
      const scope = select.value || "all";

      renderHelp(helpEl, matchHelpRule(q));

      if (q.length < minChars) {
        chipsEl.hidden = false;
        renderSuggestionList(resultsEl, suggestions, scope);
        return;
      }

      chipsEl.hidden = true;

      try {
        const queries = buildQueries(q);
        const batches = await Promise.all(
          queries.map((qq) => fetchSuggestArticles(qq, Math.max(limit * 3, 12)))
        );

        let merged = batches.flat();
        merged = filterByScope(merged, scope);
        merged = dedupeByUrl(merged).slice(0, limit);

        renderResults(resultsEl, merged, q);
        resultsEl.hidden = false;
      } catch {
        resultsEl.innerHTML = `<div class="article-live-search__empty">Suche gerade nicht verfügbar.</div>`;
        resultsEl.hidden = false;
      }
    }, DEBOUNCE_MS);

    input.addEventListener("input", runSearch);

    select.addEventListener("change", () => {
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-article-live-search]").forEach(init);
  });
})();
